import { Draft } from '@reduxjs/toolkit';
import {
  IPathQueryFieldsFragment,
  QueryType,
} from '../../../../utils/apollo/graphqlSchema';
import { INextStepType } from '../../cachedEntities';
import { assertCondition } from '../../../../utils/types';
import { IBuilder, RowType } from '../types';
import { generateMeasureRowsFromEventConditions } from './utils';

const preparePathToNextStep = (
  draft: Draft<IBuilder>,
  builderInfo: IPathQueryFieldsFragment,
  targetType: INextStepType,
) => {
  assertCondition(targetType !== QueryType.Path);
  const { startConditions, endConditions, subject } = builderInfo;

  if (targetType === QueryType.Expression) {
    draft[RowType.measures] = generateMeasureRowsFromEventConditions(
      [startConditions, endConditions],
      draft.defaultMeasureFunctions,
      subject?.name ?? null,
    );
  } else if (targetType === QueryType.DataTable) {
    draft[RowType.dataTableMeasures] = generateMeasureRowsFromEventConditions(
      [startConditions, endConditions],
      draft.defaultMeasureFunctions,
      subject?.name ?? null,
    );
  } else if (targetType === QueryType.Retention) {
    draft.retention.retentionConditions = [startConditions, endConditions];
  } else if (targetType === QueryType.Funnel) {
    draft[RowType.steps][0].eventConditions = startConditions;
    draft[RowType.steps][1].eventConditions = endConditions;
  }
};

export default preparePathToNextStep;
